export default __webpack_public_path__ + "static/media/description-location.78017e4a.png";